module.exports = __webpack_public_path__ + "img/plate_1.0fbac751.png";